import React, { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import api from "../lib/api";
import { useAuth } from "../lib/auth";

export default function AuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const { refresh } = useAuth();
  const processed = useRef(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const hash = location.hash || window.location.hash || "";
    const m = hash.match(/session_id=([^&]+)/);
    if (!m) {
      navigate("/login");
      return;
    }
    const sessionId = decodeURIComponent(m[1]);
    (async () => {
      try {
        await api.post("/auth/google/session", { session_id: sessionId });
        await refresh();
        // Strip hash & go to dashboard
        window.history.replaceState(null, "", "/dashboard");
        navigate("/dashboard", { replace: true });
      } catch (e) {
        setError("Sign-in failed. Please try again.");
        setTimeout(() => navigate("/login"), 1500);
      }
    })();
  }, [location, navigate, refresh]);

  return (
    <div className="min-h-screen grid place-items-center bg-white" data-testid="auth-callback-page">
      <div className="text-center">
        <div className="font-display text-2xl font-bold text-slate-900">Signing you in…</div>
        <div className="text-slate-500 mt-2">{error || "Securing your session."}</div>
      </div>
    </div>
  );
}
